/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileExcel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2v6H1v9h3v5h16V7.586L14.414 2zm2 15h4V8H6V4h7v5h5v11H6zM16.586 7H15V5.414zM3.26 15l1.501-2.526-1.427-2.345h1.2l1.004 1.682.979-1.682h1.152l-1.434 2.365L7.743 15h-1.2l-1.085-1.843L4.413 15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileExcel as FileExcel };
